<template>
  <!-- form -->
  <validation-observer v-slot="{ invalid, validate}" ref="employeeProfileValidation">
    <b-form class="mt-2" @submit.prevent>
      <b-row>
        <b-col sm="6">
          <b-form-group label="First Name*" label-for="fname">
            <validation-provider 
              rules="required|valid-name" 
              v-slot="{ errors }" 
              name="first name"
            >
              <b-form-input 
                v-model="employeeProfile.firstName" 
                required 
                placeholder="First Name" 
                name="fname"
                :disabled="!isEdit" 
                :state="errors.length > 0 ? false : null"

              />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Last Name*" label-for="lname">
            <validation-provider rules="required|valid-name" #default="{ errors }" name="last name">
              <b-form-input 
              v-model="employeeProfile.lastName" 
              name="lname" 
              placeholder="Last Name"
              :disabled="!isEdit" 
              :state="errors.length > 0 ? false : null" 
              required 
             />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="E-mail*" label-for="email">
            <validation-provider rules="required" #default="{ errors }" name="email">
              <b-form-input v-model="employeeProfile.email" type="email" name="email" placeholder="Email"
                :disabled="!isEdit" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="NIC*" label-for="nic">
            <validation-provider rules="required" #default="{ errors }" name="nic">
              <b-form-input v-model="employeeProfile.nic" required placeholder="NIC"
              maxlength="14"
               name="nic"  @keypress="allowAlphaNumeric($event)"
                :disabled="!isEdit" :state="errors.length > 0 ? false : null" />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Phone Number*" label-for="phoneNumber">
            <validation-provider rules="required" #default="{ errors }" name="Phone Number">
              <b-form-input v-model="employeeProfile.phoneNumber" name="phoneNumber" type="number"
                placeholder="Phone Number" :disabled="!isEdit" :state="errors.length > 0 ? false : null"
                required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Gender*" label-for="gender">
            <validation-provider rules="required" #default="{ errors }" name="gender">
              <b-form-select :options="genderOptions" v-model="employeeProfile.gender"
                :disabled="!isEdit" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="DOB*" label-for="dob">
            <validation-provider rules="required" #default="{ errors }" name="date of birth">
              <DatePicker 
                v-model="employeeProfile.dateOfBirth" 
                type="date" 
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                placeholder="Select DOB"
                :clearable="false"
                :disabled="!isEdit"
                :state="errors.length > 0 ? false : null"
                :default-value="null"
                :editable="false"
                :picker-options="{
                  shortcuts: []                }"
 
              />
              <small v-if="errors.length" class="text-danger text-end">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        
        <b-col sm="6">
          <b-form-group label="Country*" label-for="country">
            <validation-provider rules="required" #default="{ errors }" name="country">
              <b-form-select :options="countries" v-model="employeeProfile.country" placeholder="country"
                :disabled="!isEdit" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Address*" label-for="address">
            <validation-provider rules="required" #default="{ errors }" name="address">
              <b-form-input name="address" placeholder="Address" v-model="employeeProfile.address"
                :disabled="!isEdit" :state="errors.length > 0 ? false : null" required />
              <small v-if="errors.length" class="text-danger text-end">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <CustomFieldsDetails
      
  :AdditionalFields="employeeProfile.additionalFields"
  :ModuleReference="'Employee'"
:ReadOnlyFields= "!isEdit"
  @onchange="additionalFieldChanges"
  :disabled="isDisabled"
></CustomFieldsDetails>

    </b-form>
  </validation-observer>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BAvatar,
  BFormSelect,
  BFormDatepicker,
} from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css"; // Import styles
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { _calculateAge, customSwal } from "@/libs/customFn";
import { FullCountryList, GenderList } from "@/libs/defaultList";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BAvatar,
    BFormSelect,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    CustomFieldsDetails,
    DatePicker
  },
  directives: {},
  props: {
    employeeProfile: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isDisabled: false,
      countries: FullCountryList,
      genderOptions: GenderList,
      disableFutureDates:false,
      required,
      isEdit: false,
      maxDate: new Date().toISOString().split('T')[0],
    };
  },
  methods: {
    allowAlphaNumeric(event) {
      const charCode = event.which ? event.which : event.keyCode;
      const charStr = String.fromCharCode(charCode);

      if (!charStr.match(/^[a-zA-Z0-9]$/)) {
        event.preventDefault();
      }
    },

    additionalFieldChanges(customFields) {
      this.employeeProfile.additionalFields = customFields;
    },

    checkEditMode() {
      const currentPath = this.$route.path.toLowerCase();
      this.isEdit = !currentPath.includes("/view/");
    },

    async submitProfileForm() {
      const isValid = await this.$refs.employeeProfileValidation.validate();
      console.log("employeeProfileValidation emitted: ", isValid);
      if (isValid) {
        this.$emit("employeeProfileValidation", this.employeeProfile);
      }
      return isValid;
    },
  },

  /*setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },*/
  mounted() {
    this.checkEditMode();
  },

  watch: {
    $route: "checkEditMode",
    // Watch for changes to the individual object
    employeeProfile: {
      handler(newVal) {
        // Emit the updated individual data to the parent
        console.log("changes", newVal);
        this.$emit("updateEmployeeProfile", newVal);
      },
      deep: true, // Watch for nested changes in the individual object
    },
    "employeeProfile.dateOfBirth"(dob) {
      const age = _calculateAge(new Date(dob));
      if (age < 16) {
        customSwal("Age cannot be less than 16.", "Error", "error");
      }
    },
  },
};
</script>
